//ContractorAgreementList.jsx
import React, { useCallback, useEffect, useState, useRef } from 'react';
import { useSelector } from 'react-redux';
import { Link, useLocation } from 'react-router-dom';
import useFetch from '../../hooks/useFetch';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarAlt, faPlus } from '@fortawesome/free-solid-svg-icons';
import Loader from '../../components/utils/Loader';
import Tooltip from '../../components/utils/Tooltip';
import MainLayout from '../../layouts/MainLayout';

const ContractorAgreementList = () => {
  const location = useLocation();
  const authState = useSelector(state => state.authReducer);
  const [contractAgreements, setContractAgreements] = useState([]);
  const [fetchData, { loading }] = useFetch();
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [name, setName] = useState('');
  const [place, setPlace] = useState('');
  const [tags, setTags] = useState('');
  const [contractAgreementTo, setPurpose] = useState('');
  const [purposeHead, setPurposeHead] = useState('');
  const [selectedContractAgreementId, setSelectedContractAgreementId] = useState(null);
  const [iApplauded, setIApplauded] = useState(false);
  const [selfContractAgreement, setSelfContractAgreement] = useState(false);
  const [contractAgreementForMe, setContractAgreementForMe] = useState(false);
  const [contractAgreementRoute, setContractAgreementRoute] = useState("i-applauded");

  const fetchContractAgreements = useCallback(async () => {
    const config = {
      url: "/contractoragreement/list",
      method: "post",
      headers: { Authorization: authState.token },
      data: { userId: authState.user._id }
    };
  
    // console.log("My contract Agreement Search Payload: ", config); // Ensure the userId is correct
  
    try {
      const response = await fetchData(config, { showSuccessToast: false });
      // console.log("response Contract Agreements: ", response); // Check the full response
      setContractAgreements(response.agreements);
    } catch (error) {
      console.error('Error fetching Contract Agreements:', error);
    }
  }, [authState.token, authState.user._id, fetchData, setContractAgreements]);
  
  useEffect(() => {
    fetchContractAgreements();
  }, [fetchContractAgreements]);

  const [isDeleteClicked, setIsDeleteClicked] = useState(false);
  const deleteClicked = () => {
    setIsDeleteClicked(true);
  }
  
  const noDeleteClicked = () => {
    setIsDeleteClicked(false);
  }
  
  const handleDelete = (id) => {
    const config = {
      url: `/contractoragreement/${id}`,
      method: "delete",
      headers: { Authorization: authState.token }
    };
    fetchData(config).then(() => fetchContractAgreements());
    setIsDeleteClicked(false);
  }

  const handleView = (contractAgreementId) => {
    setSelectedContractAgreementId(prevId => (prevId === contractAgreementId ? null : contractAgreementId));
  };

  const handleCloseContractAgreementDetails = () => {
    setSelectedContractAgreementId(null);
  };

  const handleContractAgreementClick = (ContractAgreementId) => {
    setSelectedContractAgreementId(ContractAgreementId);
  };

  const handleContractAgreementShare = (ContractAgreementId) => {
    setSelectedContractAgreementId(ContractAgreementId);
  };

  const handleContractAgreementSave = (ContractAgreementId) => {
    setSelectedContractAgreementId(ContractAgreementId);
  };

  const handleContractAgreementPrint = (ContractAgreementId) => {
    setSelectedContractAgreementId(ContractAgreementId);
  };

  const formatDateTime = (date) => {
    const options = {
        year: 'numeric', month: '2-digit', day: '2-digit',
        hour: '2-digit', minute: '2-digit', second: '2-digit',
        hour12: false
    };
    const jsDate = new Date(date);
    const day = jsDate.getDate().toString().padStart(2, '0');
    const month = (jsDate.getMonth() + 1).toString().padStart(2, '0');
    const year = jsDate.getFullYear();
    const hours = jsDate.getHours().toString().padStart(2, '0');
    const minutes = jsDate.getMinutes().toString().padStart(2, '0');
    const seconds = jsDate.getSeconds().toString().padStart(2, '0');
    return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
};

  const sortedContractAgreements = [...contractAgreements].sort((a, b) => new Date(b.startDate) - new Date(a.startDate));

  return (
    <MainLayout>
      <div className='mt-12'>
        <h3 className='text-lg mt-1 border-b border-b-gray-300 text-white'>Contract Agreement</h3>
        <div className="p-4 mt-4">
            <div className="mt-2">
              {contractAgreements && contractAgreements.length !== 0 && (
                <div className="flex justify-between items-center">
                  <div>
                    <h3 className='text-xl mt-1 mx-2 text-yellow-200'>{contractAgreements.length} Contract Agreements By You Found!</h3>
                  </div>
                  <div className='mr-4'>
                    <Link to='/contractorAgreement/add' className='block w-full h-full px-1 py-2 ml-4 bg-blue-500'>
                      <FontAwesomeIcon className="bg-blue-500 mr-4" icon={faPlus} />  Add New
                    </Link>
                </div>
              </div>
              )}
            </div>
          {loading ? (
            <Loader />
          ) : (
            <div>
              {contractAgreements && contractAgreements.length === 0 ? (
                <div className='h-[300px] flex items-center justify-center gap-4 text-yellow-300'>
                  <div className="flex justify-between items-center">
                  <div>
                  <h3 className='text-xl mt-1 mx-2 text-orange-400'>No Contract Agreement Record Found!</h3>
                  </div>
                  <div>
                  <Link to='/contractorAgreement/add' className='block w-full h-full px-1 py-2 ml-4 bg-blue-500'>
                    <FontAwesomeIcon className="bg-blue-500 mr-4" icon={faPlus} />  Add New
                  </Link>
                </div>
              </div>
                </div>
              ) : (
                sortedContractAgreements.map((contractAgreement, index) => (
                  <div key={contractAgreement._id} className="bg-gray-600 my-4 p-4 text-white rounded-lg shadow-lg">
                    <div className='flex'>
                      <span className='font-medium'>#{index + 1} {'To '}{contractAgreement.establishmentCode}{' On '}{formatDateTime(contractAgreement.agreementDate)}</span>
                      <Tooltip text={"View details"} position={"top"}>
                        <span className='ml-auto mr-4 text-blue-500 cursor-pointer' onClick={() => handleView(contractAgreement._id)}>
                          <i className="fa-solid fa-eye"></i>
                        </span>
                      </Tooltip>
                      <Tooltip text={"Edit this record"} position={"top"}>
                        <Link to={`/contractorAgreement/${contractAgreement._id}`} className='mr-4 text-green-600 cursor-pointer'>
                          <i className="fa-solid fa-pen"></i>
                        </Link>
                      </Tooltip>
                      <Tooltip text={"Delete this record"} position={"top"}>
                          <span className='text-red-500 cursor-pointer mr-2' onClick={() => deleteClicked()}>
                            <i className="fa-solid fa-trash"></i>
                          </span>
                      </Tooltip>
                      { isDeleteClicked && (
                        <div>
                          <div
                            className="fixed inset-0 bg-black bg-opacity-80 flex items-center justify-center"
                            style={{ zIndex: 1000 }}
                          >
                            <div className="w-6/12 flex flex-row justify-center bg-blue-200 text-black border-b border-b-gray-300 mr-4 ml-4 p-4">
                                <button
                                  className="bg-red-700 w-40"
                                  onClick={() =>  handleDelete(contractAgreement._id) }
                                  style={{ maxWidth: "150px" }}
                                >
                                  Confirm To Delete
                                </button>
                                <button
                                  className="bg-yellow-300 ml-4 text-black w-40"
                                  onClick={() =>  noDeleteClicked() }
                                  style={{ maxWidth: "150px" }}
                                >
                                  No I Do Not Want To Delete
                                </button>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                    {/* <div className='whitespace-pre  text-blue-700'>{contractAgreement.title}</div> */}
                    {selectedContractAgreementId === contractAgreement._id && (
                      <div className='bg-gray-200 text-black'>
                        <p><strong>Think5Whys Contractor Code: </strong>{contractAgreement.agreementCode}</p>
                        <p><strong>Contract Number: </strong>{contractAgreement.contractNumber}</p>
                        <p><strong>Contractor Name: </strong>{contractAgreement.contractorName}</p>
                        <p><strong>Sub-Contractor Name: </strong>{contractAgreement.subContractorName}</p>
                        <p><strong>Principal Employer Name: </strong>{contractAgreement.establishmentName}</p>
                        <p><strong>Location:</strong> {contractAgreement.location}</p>
                        <p><strong>Location Address:</strong> {contractAgreement.locationAddress}</p>
                        <p><strong>Contractor Contact Person:</strong> {contractAgreement.contractorContactPerson}</p>
                        <p><strong>Max Contract Workers:</strong> {contractAgreement.maxContractLabour}</p>     
                        <p><strong>Nature of Work:</strong> {contractAgreement.natureOfWork}</p>
                        <p><strong>Agreement Date:</strong> {formatDateTime(contractAgreement.agreementDate)}</p>
                        <p><strong>Start Date:</strong> {formatDateTime(contractAgreement.startDate)}</p>
                        <p><strong>Completion Date:</strong> {formatDateTime(contractAgreement.completionDate)}</p>
                        <p><strong>Fee paid:</strong> contractAgreement.feePaid</p>
                        <p><strong>Deposit paid:</strong>contractAgreement.depositPaid</p>
                      </div>
                    )}
                  </div>
                ))
              )}
            </div>
          )}
        </div>
      </div>
    </MainLayout>
  )
}

export default ContractorAgreementList;
